import { isArray, isObject } from 'lodash';

export type IHashableKey = string | Array<string | object | undefined>;

export type IHashKeyOptions = {
  sortKeys?: boolean;
};

export const hashKey = (key: IHashableKey, options?: IHashKeyOptions): string =>
  JSON.stringify(
    isArray(key) ? (options?.sortKeys ? key.sort() : key) : key,
    (_, value) =>
      isObject(value)
        ? Object.keys(value)
            .sort()
            .reduce(
              (acc, key) => ({
                ...acc,
                [key]: value[key as keyof typeof value],
              }),
              {},
            )
        : (value as unknown),
  );
